export function getByPath<T = any, D = undefined>(
    obj: T,
    path: string,
    defaultValue?: D
): any {
    if (!obj || !path) return defaultValue;
    // поддержим a.b[0].c и a['b'].c
    const parts = path
        .replace(/\[(\w+)\]/g, '.$1')     // a[0] -> a.0
        .replace(/\['([^']+)'\]/g, '.$1') // a['b'] -> a.b
        .replace(/\["([^"]+)"\]/g, '.$1') // a["b"] -> a.b
        .replace(/^\./, '')
        .split('.');

    let cur: any = obj;
    for (const key of parts) {
        if (cur == null) return defaultValue;
        cur = cur[key];
    }
    return cur ?? defaultValue;
}
